import React from "react";

export default function Bookmark({
  color = "transparent",
  outline = "#fff",
  ...restProps
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={20}
      viewBox="0 0 15 20"
      className="workspace-bookmark-icon"
      {...restProps}
    >
      <g id="bookmark-path" fill="none" fillRule="nonzero">
        <polygon
          fill={color}
          stroke={outline}
          strokeLinecap="square"
          strokeWidth="1.5"
          points="14 18 14 1 1 1 1 18 7.5 14.3620238"
        />
      </g>
    </svg>
  );
}
